import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { v4 as uuidv4 } from 'uuid'
import { zustandPlugin } from '@/modules/shared/openreplay'

type State = {
  ids: string[]
}

type Actions = {
  startLoading: () => () => void
}

export const useLoadingStore = create<State & Actions>()(
  devtools(
    zustandPlugin((set) => ({
      ids: [],
      startLoading: () => {
        const id = uuidv4()
        set(
          (s) => ({ ids: [...s.ids, id] }),
          false,
          'start',
        )
        return () =>
          set(
            (s) => ({ ids: s.ids.filter((l) => l !== id) }),
            false,
            'stop',
          )
      },
    }), 'loading'),
    { name: 'EasyTacho', store: 'loading' },
  ),
)

export const selectLoading = (s: State): boolean => s.ids.length > 0
